import { AddUserError } from "../interface";
import { MOBILE_NUMBER_LENGTH, PAN_LENGTH } from "./CreateCustomer.constants";

/**
 * 
 * @param sourceEntityIDs - The list of source entity IDs to filter
 * @param text - The text to filter the source entity IDs
 * @returns The filtered list of source entity IDs
 */


export const filterSourceEntityIDs = (sourceEntityIDs: any, text: string) => {
    const query = text?.trim().toLowerCase();
  
    if (!query) return sourceEntityIDs ?? [];
  
    const matched: any[] = [];
    const unmatched: any[] = [];
  
    for (const item of sourceEntityIDs ?? []) {
      (item?.name?.toLowerCase().includes(query) ? matched : unmatched).push(item);
    }
  
    return [...matched, ...unmatched];
};
/**
 * Pasted phone numbers usually carry formatting ("+91 98765 43210", a trailing
 * newline from a sheet, …). The `maxLength` attribute silently truncates that
 * to the first 10 characters, so the field keeps failing validation even though
 * the pasted number was correct. Strip everything that is not a digit, drop a
 * leading 91 country code, and keep the last 10 digits.
 */
export const sanitizeMobileInput = (value: string) => {
  let digits = (value ?? "").replace(/\D/g, "");

  if (digits.length > MOBILE_NUMBER_LENGTH && digits.startsWith("91"))
    digits = digits.slice(2);

  return digits.slice(0, MOBILE_NUMBER_LENGTH);
};

/**
 * Same problem for PAN — spaces and lowercase characters come along with the
 * paste and push the real characters past `maxLength`.
 */
export const sanitizePanInput = (value: string) =>
  (value ?? "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, PAN_LENGTH);

/**
 * addUser returns `error` either as a plain string or, when the lead was
 * disqualified in a previous attempt, as an object holding the reason codes.
 */
export const getAddUserError = (error: unknown): AddUserError => {
  if (!error) return {};
  if (typeof error === "string") return { message: error };
  
  return (error as AddUserError) || {};
};

/**
 * The acknowledgement popup is shown only when the backend explicitly opts out
 * of the default error popup and sends back the disqualification reasons.
 */
export const shouldAcknowledgeDisqualification = (error: AddUserError) =>
  error?.displayErrorMessagePopup === false &&
  (error?.disqualificationReasons?.length ?? 0) > 0;
